export default __webpack_public_path__ + "icon-share.a4f70165.png";